import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

declare const AksPageLoad: any;
declare function AksresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function voiceOnKeyPress(value, key, targetid): any;
declare var $: any;
declare function voiceOnSaveMsg(Message): any;

@Component({
  selector: 'app-ask-aquestion',
  templateUrl: './ask-aquestion.component.html',
  styleUrls: ['./ask-aquestion.component.css']
})
export class AskAQuestionComponent implements OnInit {
  AskQAForm: FormGroup;
  datasaved = false;
  message: string;

  constructor(private formbuilder: FormBuilder, private browseobligorService: BrowseobligorService, private router: Router) { }

  onKeyUp(event: any) {
    debugger;
    if (event.keyCode == 9 || event.keyCode == 13) {
      AksresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
    }
    if (event.keyCode == 32) {
      if (event.target.id == "btnSubmit" || event.target.id == "btnCancel") {
        event.preventDefault();
        return;
      }
    }
  };

  onkeypress(event: any) {
    debugger;
    if (event.keyCode == 32) {
      if (event.target.id == "btnSubmit" || event.target.id == "btnCancel") {
        event.preventDefault();
        return;
      }
    }
    voiceOnKeyPress(event.target.value, event.key, event.target.id);
  }

  setFormState(): void {
    this.AskQAForm = this.formbuilder.group({
      Subject: ['', [Validators.required]],
      question: ['', [Validators.required]]   
    })
  }

  ngOnInit() {
    debugger;    

    this.setFormState();
    if (sessionStorage.length == 0) {
      this.router.navigate(['/registration']);      
    }
    else if (sessionStorage.length == 1) {
      //============Voice Annotation On/Off=========
      if ($('#hidVoiceOnOff').val() == "OFF") {
        $('#btnVoiceAnnotation').val('OFF');
        $('#hidVoiceOnOff').val('OFF');
        $('#btnPlayPause').css('display', 'none');
      }
      else {
        $('#btnVoiceAnnotation').val('ON');
        $('#hidVoiceOnOff').val('ON');
        $('#btnPlayPause').css('display', 'block');
      }

      //=========Caption Hide Show=============//
      if ($('#hidglbVarOnOff').val() == "OFF") {
        $('#captionhideshow').hide();
        $('#btnOnOff').val('OFF')
      }
      else {
        $('#captionhideshow').show();
        $('#btnOnOff').val('ON')
      }


      AksPageLoad();
      var OBLIGOR_DESC = localStorage.OBLIGOR_DESC;
      document.getElementById("lblValueObligor").innerText = OBLIGOR_DESC;
      document.getElementById("spnValueObligor").innerText = OBLIGOR_DESC;  
      document.getElementById("lblValuecontact").innerText = JSON.parse(sessionStorage.sessionData).firstName + " " + JSON.parse(sessionStorage.sessionData).lastName;
      document.getElementById("spnValuecontact").innerText = JSON.parse(sessionStorage.sessionData).firstName + " " + JSON.parse(sessionStorage.sessionData).lastName;
    }    
  }
  
  onClick(event: any) {
    //debugger;    
    var OBLIGOR_ID = localStorage.OBLIGOR_ID;   
    var subject = <HTMLInputElement>document.getElementById("txtsubject");
    var question = <HTMLInputElement>document.getElementById("txtquestion");
    this.AddQA(OBLIGOR_ID,subject.value, question.value);
    this.datasaved = true;
    this.message = "Your question has been successfully submitted.";
    subject.value = null;
    question.value = null;
    this.setFormState();
    voiceOnSaveMsg(this.message);   
  }

  onCancelClick() {
    var subject = <HTMLInputElement>document.getElementById("txtsubject");
    var question = <HTMLInputElement>document.getElementById("txtquestion");
    subject.value = null;
    question.value = null;
    this.message = "";
    return;
  }

  AddQA(obligorId: string, subject: string, question: string) {
    debugger;
    this.browseobligorService.AddQA(obligorId, subject, question).subscribe(data => {
    },
      error => {
        console.log(error);
        console.log(error.status);
        if (error.status == "403") {
          sessionStorage.removeItem("sessionData");
          this.checkSession_onSearch();

        }
    });
  }
  checkSession_onSearch() {
    // check session is valid
    if (!sessionStorage['sessionData']) {
      this.router.navigate(['registration']);
      return;

    }
  }
}
